import React, { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { StaticImage } from "gatsby-plugin-image"

const EventRegistrationForm = () => {

    useEffect(() => {
    const recaptchaScript = document.createElement("script");
    recaptchaScript.src = "https://www.google.com/recaptcha/api.js";
    recaptchaScript.async = true;
    recaptchaScript.defer = true;
    document.body.appendChild(recaptchaScript);
  }, []);

    const eventForm = `
<!-- Note :
   - You can modify the font style and form style to suit your website. 
   - Code lines with comments Do not remove this code are required for the form to work properly, make sure that you do not remove these lines of code. 
   - The Mandatory check script can modified as to suit your business needs. 
   - It is important that you test the modified form before going live.-->
<div id = 'crmWebToEntityForm' class = 'zcwf_lblLeft crmWebToEntityForm' style = 'background-color: white;color: black;max-width: 600px;'>
	<meta name = 'viewport' content = 'width=device-width, initial-scale=1.0'>
		<META HTTP-EQUIV = 'content-type' CONTENT = 'text/html;charset=UTF-8'>
			<form id = 'webform6383044000001985495' action = 'https://crm.zoho.com/crm/WebForm' name = WebForm6383044000001985495 method = 'POST' onSubmit = 'javascript:document.charset="UTF-8"; return checkMandatory6383044000001985495()' accept-charset = 'UTF-8'>
				<input type = 'text' style = 'display:none;' name = 'xnQsjsdp' value = '7c449202684cc7a0914604dbc14165a1d4ddd0e2c7388cc9a5e03a608b42bce5'>
				</input>
				<input type = 'hidden' name = 'zc_gad' id = 'zc_gad' value = ''>
				</input>
				<input type = 'text' style = 'display:none;' name = 'xmIwtLD' value = '82068f598d3e307413c84aba6d3de15b7cfcb38f78f6989f538f06f9a868e81034aa3563bfa1bb9ceea2a504a1a4761f'>
				</input>
				<input type = 'text' style = 'display:none;' name = 'actionType' value = 'Q3VzdG9tTW9kdWxlMg=='>
				</input>
				<input type = 'text' style = 'display:none;' name = 'returnURL' value = 'null'>
				</input>
				<!-- Do not remove this code. -->
				<style>
					html,body{
						margin: 0px;
					}
					#crmWebToEntityForm.zcwf_lblLeft{
						width: 100%;
						margin: 0 auto;
						box-sizing: border-box;
					}
					#crmWebToEntityForm.zcwf_lblLeft *{
						box-sizing: border-box;
					}
					#crmWebToEntityForm {text-align: left;
					}
					#crmWebToEntityForm *{
					direction: ltr;
					}
					.zcwf_lblLeft .zcwf_title{
					word-wrap: break-word;
					font-weight: bold }
					.zcwf_lblLeft.cpT_primaryBtn:hover{
					background: linear-gradient(#02acff 0,#006be4 100%)no-repeat padding-box !important;
					box-shadow: 0 -2px 0 0  #0159b9 inset !important;
					border: 0 !important;
					color:  #fff !important;
					outline: 0 !important;
					}
					.zcwf_lblLeft .zcwf_col_fld input[ type  = text], input[ type  = password], .zcwf_lblLeft .zcwf_col_fld textarea{
					width: 100%;
					resize: vertical;
					border-radius: 2px;
					float: left;
					}
					.zcwf_lblLeft .zcwf_col_lab{
					width: 100%;
					word-break: break-word;
					margin-right: 10px;
					margin-top: 5px;
					float: left;
					min-height: 1px;
					}
					.zcwf_lblLeft .zcwf_col_fld{
					float: left;
					width: 100%;
					padding: 0px 6px 0px;
					position: relative;
					margin-top: 5px;
					}
					.zcwf_lblLeft .zcwf_privacy {padding: 6px;
					}
					.zcwf_lblLeft .wfrm_fld_dpNn {display: none;
					}
					.dIB {display: inline-block;
					}
					.zcwf_lblLeft .zcwf_col_fld_slt{
					width: 100%;
					background:  #F0F0F0;
					border-radius: 4px;
					font-size: 14px;
					float: left;
					resize: vertical;
					padding: 8px;
					}
                    .zcwf_row {
                        display: grid;
                    }
					.zcwf_lblLeft .zcwf_row:after, .zcwf_lblLeft .zcwf_col_fld:after{
					content: '';
					display: table;
					clear: both;
					}
					.zcwf_lblLeft .zcwf_col_help{
					float: left;
					margin-left: 7px;
					font-size: 14px;
					max-width: 35%;
					word-break: break-word;
					}
					.zcwf_lblLeft .zcwf_help_icon{
					cursor: pointer;
					width: 16px;
					height: 16px;
					display: inline-block;
					background:  #fff;
					border: 1px solid  #c0c6cc;
					color:  #c1c1c1;
					text-align: center;
					font-size: 11px;
					line-height: 16px;
					font-weight: bold;
					border-radius: 50%;
					}
					.zcwf_lblLeft .zcwf_row {margin: 15px 0px;
					}
					.zcwf_lblLeft .formsubmit{
					margin-right: 5px;
					cursor: pointer;
					font-size: 14px;
					}
					.zcwf_lblLeft .zcwf_privacy_txt{
					width: 90%;
					color: rgb(0, 0, 0);
					font-size: 14px;
					display: inline-block;
					vertical-align: top;
					color: var(--baseColor);
					padding-top: 2px;
					margin-left: 6px;
					}
					.zcwf_lblLeft .zcwf_button{
					font-size: 14px;
					padding: 10px;
					border-radius: 4px;
					cursor: pointer;
                    color: white;
                    width: 100%;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
                    background-color: rgba(249, 37, 57, 1);
					}
					.zcwf_lblLeft .zcwf_tooltip_over{
					position: relative;
					}
					.zcwf_lblLeft .zcwf_tooltip_ctn{
					position: absolute;
					background:  #dedede;
					padding: 3px 6px;
					top: 3px;
					border-radius: 4px;
					word-break: break-word;
					min-width: 100px;
					max-width: 150px;
					color: var(--baseColor);
					z-index: 100;
					}
					.zcwf_lblLeft .zcwf_ckbox{
					float: left;
					}
					.zcwf_lblLeft .zcwf_file{
					width: 55%;
					box-sizing: border-box;
					float: left;
					}
					.cBoth:after{
					content: '';
					display: block;
					clear: both;
					}
					@media all and  (max-width: 600px){
					.zcwf_lblLeft .zcwf_col_lab, .zcwf_lblLeft .zcwf_col_fld{
					width: auto;
					float: none !important;
					}
					.zcwf_lblLeft .zcwf_col_help {width: 40%;
					}
					}
                    input {
                        padding: 0.375rem;
                        background-color: rgba(172, 172, 172, 0.25);
                        border-radius: 0.375rem;
                        border: none;
                    }
        
                    button {
                        width: 100%;
                    }
				</style>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'NAME'>First Name
							<span style = 'color:red;'>*</span>
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'text' id = 'NAME' aria-required = 'true' aria-label = 'NAME' name = 'NAME' aria-valuemax = '120' maxlength = '120'>
						</input>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'COBJ2CF9'>Last Name
							<span style = 'color:red;'>*</span>
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'text' id = 'COBJ2CF9' aria-required = 'true' aria-label = 'COBJ2CF9' name = 'COBJ2CF9' aria-valuemax = '255' maxlength = '255'>
						</input>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'Email'>Email
							<span style = 'color:red;'>*</span>
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'text' ftype = 'email' autocomplete = 'false' id = 'Email' aria-required = 'true' aria-label = 'Email' name = 'Email' aria-valuemax = '100' crmlabel = '' maxlength = '100'>
						</input>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'COBJ2CF4'>Phone Number
							<span style = 'color:red;'>*</span>
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'text' id = 'COBJ2CF4' aria-required = 'true' aria-label = 'COBJ2CF4' name = 'COBJ2CF4' aria-valuemax = '30' maxlength = '30'>
						</input>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'COBJ2CF5'>Organisation
							<span style = 'color:red;'>*</span>
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'text' id = 'COBJ2CF5' aria-required = 'true' aria-label = 'COBJ2CF5' name = 'COBJ2CF5' aria-valuemax = '255' maxlength = '255'>
						</input>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'COBJ2CF1'>Job Title
							<span style = 'color:red;'>*</span>
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'text' id = 'COBJ2CF1' aria-required = 'true' aria-label = 'COBJ2CF1' name = 'COBJ2CF1' aria-valuemax = '255' maxlength = '255'>
						</input>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'COBJ2CF6'>Cateogry
							<span style = 'color:red;'>*</span>
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<select class = 'zcwf_col_fld_slt' role = 'combobox' aria-expanded = 'false' aria-haspopup = 'listbox' id = 'COBJ2CF6' onChange = 'addAriaSelected6383044000001985495()' aria-required = 'true' aria-label = 'COBJ2CF6' name = 'COBJ2CF6'>
							<option value = '-None-'>-None-</option>
							<option value = 'Advertiser'>Advertiser</option>
							<option value = 'Agency'>Agency</option>
							<option value = 'Publisher'>Publisher</option>
							<option value = 'Martech&#x20;Provider'>Martech Provider</option>
							<option value = 'Techonology'>Techonology</option>
							<option value = 'Freelancer'>Freelancer</option>
							<option value = 'Other'>Other</option>
						</select>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'COBJ2CF8'>What is your goal for this event</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<select class = 'zcwf_col_fld_slt' role = 'combobox' aria-expanded = 'false' aria-haspopup = 'listbox' id = 'COBJ2CF8' onChange = 'addAriaSelected6383044000001985495()' aria-required = 'false' aria-label = 'COBJ2CF8' name = 'COBJ2CF8'>
							<option value = '-None-'>-None-</option>
							<option value = 'Networking&#x20;with&#x20;industry&#x20;leaders'>Networking with industry leaders</option>
							<option value = 'Learning&#x20;new&#x20;performance&#x20;marketing&#x20;strategies'>Learning new performance marketing strategies</option>
							<option value = 'Exploring&#x20;partnerships&#x20;and&#x20;collaborations'>Exploring partnerships and collaborations</option>
							<option value = 'Other'>Other</option>
						</select>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab' style = 'font-size:12px; font-family: Arial;'>
						<label for = 'COBJ2CF7'>How did you hear about this event
							<span style = 'color:red;'>*</span>
						</label>
					</div>
					<div class = 'zcwf_col_fld'>
						<select class = 'zcwf_col_fld_slt' role = 'combobox' aria-expanded = 'false' aria-haspopup = 'listbox' id = 'COBJ2CF7' onChange = 'addAriaSelected6383044000001985495()' aria-required = 'true' aria-label = 'COBJ2CF7' name = 'COBJ2CF7'>
							<option value = '-None-'>-None-</option>
							<option value = 'Email&#x20;invitaiton'>Email invitaiton</option>
							<option value = 'Social&#x20;media'>Social media</option>
							<option value = 'Industry&#x20;association'>Industry association</option>
							<option value = 'Colleague'>Colleague</option>
							<option value = 'Other'>Other</option>
						</select>
						<div class = 'zcwf_col_help'>
						</div>
					</div>
				</div>
				<input type = 'text' type = 'hidden' style = 'display: none;' name = 'aG9uZXlwb3Q' value = ''/>
				<div class = 'zcwf_row'>
					<div class = 'zcwf_col_lab'>
					</div>
					<div class = 'zcwf_col_fld'>
						<input type = 'submit' id = 'formsubmit' role = 'button' class = 'formsubmit zcwf_button' value = 'Submit' aria-label = 'Submit' title = 'Submit'>
							</div>
						</div>
						<script>
							function addAriaSelected6383044000001985495 (){
								var optionElem = event.target;
								var previousSelectedOption = optionElem.querySelector ( '[aria-selected=true]' );
								if( previousSelectedOption ){
									previousSelectedOption.removeAttribute ( 'aria-selected' );
								}
								optionElem.querySelectorAll ( 'option' )[ optionElem.selectedIndex ].ariaSelected = 'true';
							}
							function validateEmail6383044000001985495 (){
								var form = document.forms[ 'WebForm6383044000001985495' ];
								var emailFld = form.querySelectorAll ( '[ftype=email]' );
								var i;
								for( i = 0; i < emailFld.length; i++ ){
									var emailVal = emailFld[ i ].value;
									if((emailVal.replace( /^\s+|\s+$/g,'' )).length != 0 ){
										var atpos = emailVal.indexOf ( '@' );
										var dotpos = emailVal.lastIndexOf ( '.' );
										if( atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailVal.length ){
											alert ( 'Please enter a valid email address. ' );
											emailFld[ i ].focus ();
											return false;
										}
									}
								}
								return true;
							}
							function checkMandatory6383044000001985495 (){
								var mndFileds = new Array ( 'NAME', 'Email', 'COBJ2CF1', 'COBJ2CF4', 'COBJ2CF5', 'COBJ2CF6', 'COBJ2CF7', 'COBJ2CF9' );
								var fldLangVal = new Array ( 'First\x20Name', 'Email', 'Job\x20Title', 'Phone\x20Number', 'Organisation', 'Cateogry', 'How\x20did\x20you\x20hear\x20about\x20this\x20event', 'Last\x20Name' );
								for( i = 0; i < mndFileds.length; i++ ){
									var fieldObj = document.forms[ 'WebForm6383044000001985495' ][ mndFileds[ i ]];
									if( fieldObj ){
										if(((fieldObj.value ).replace( /^\s+|\s+$/g,'' )).length == 0 ){
											if( fieldObj.type == 'file' ){
												alert ( 'Please select a file to upload.' );
												fieldObj.focus ();
												return false;
											}
											alert ( fldLangVal[ i ] + ' cannot be empty.' );
											fieldObj.focus ();
											return false;
										}
										else if( fieldObj.nodeName == 'SELECT' ){
											if( fieldObj.options[fieldObj.selectedIndex].value == '-None-' ){
												alert ( fldLangVal[ i ] + ' cannot be none.' );
												fieldObj.focus ();
												return false;
											}
										}
										else if( fieldObj.type == 'checkbox' ){
											if( fieldObj.checked == false ){
												alert ( 'Please accept  ' + fldLangVal[ i ]);
												fieldObj.focus ();
												return false;
											}
										}
										try {
											if( fieldObj.name == 'Last Name' ){
												name = fieldObj.value;
											}
										}
										catch ( e ){}
									}
								}
								if( !validateEmail6383044000001985495()){
									return false;
								}
								var urlparams = new URLSearchParams ( window.location.search );
								if( urlparams.has( 'service' ) && ( urlparams.get( 'service' ) === 'smarturl' )){
									var webform = document.getElementById ( 'webform6383044000001985495' );
									var service = urlparams.get ( 'service' );
									var smarturlfield = document.createElement ( 'input' );
									smarturlfield.setAttribute ( 'type', 'hidden' );
									smarturlfield.setAttribute ( 'value', service );
									smarturlfield.setAttribute ( 'name', 'service' );
									webform.appendChild ( smarturlfield );
								}
								document.querySelector ( '.crmWebToEntityForm .formsubmit' ).setAttribute ( 'disabled', true );
							}
							function tooltipShow6383044000001985495 ( el ){
								var tooltip = el.nextElementSibling;
								var tooltipDisplay = tooltip.style.display;
								if( tooltipDisplay == 'none' ){
									var allTooltip = document.getElementsByClassName ( 'zcwf_tooltip_over' );
									for( i = 0; i < allTooltip.length; i++ ){
										allTooltip[ i ].style.display = 'none';
									}
									tooltip.style.display = 'block';
								}
								else {
									tooltip.style.display = 'none';
								}
							}
						</script>
					</form>
				</div>
    `

    return (
        <section className='my-16 lg:my-32 lg:max-w-[1440px] mx-auto'>
            <div className='mx-[6%] lg:mx-[5%]'>
                <p className='text-[#454444] text-2xl lg:text-5xl font-bold text-center pt-9'>Event Registration Form</p>
                <p className='mt-5 text-base lg:text-xl text-center pb-6'> Resetting Everything You Know About Performance Marketing</p>
                <div className='lg:flex items-end justify-between space-y-4 lg:space-y-0 mt-2 bg-[#F4C9CA] rounded-2xl'>
                    <StaticImage
                        src='../images/Artboard.png'
                        alt='form image'
                        className='hidden lg:block lg:w-[690px] lg:h-[832px] rounded-2xl m-6'
                        placeholder="blurred"
                        quality="100"
                    />
                    <div className='lg:pr-6 mx-2 py-6 flex justify-center'>
                        <div className='bg-white rounded-2xl lg:w-[500px] pt-6 px-5 lg:px-11 pb-6 h-full ' dangerouslySetInnerHTML={{ __html: eventForm }}>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default EventRegistrationForm